<template>
    <EditServiceReport1></EditServiceReport1>
</template>
<script>
    import EditServiceReport1 from '@/components/EditServiceReport1.vue'
    export default {
        name: 'employee-sign',
        components: {
            EditServiceReport1
        }
    }
</script>